import { createSlice } from '@reduxjs/toolkit';
import {
    addClient,
    fetchClients,
    detailClient,
    editClient,
    canDeleteClient,
    deleteClient,
    addBranch,
    updateBranch,
    deleteBranch
}  from '../actions/client';

export const clientSlice = createSlice({
    name: 'client',
    initialState: {
        loading: false,
        data: [],
        current: [],
        canDeleteCurrent: false,
        currentClientLoading: false
    },
    reducers: {

    },
    extraReducers:(builder) => {
        builder
        // ADD CLIENT
        .addCase(addClient.pending,(state) => { state.loading = true })
        .addCase(addClient.fulfilled,(state, action) => { 
            state.loading = false;
            state.current = action.payload
        })
        .addCase(addClient.rejected, (state) => { state.loading = false  })
        // FETCH CLIENTS
        .addCase(fetchClients.pending,(state) => { state.loading = true })
        .addCase(fetchClients.fulfilled,(state, action) => { 
            state.loading = false;
            state.data = action.payload
        })
        .addCase(fetchClients.rejected, (state) => { state.loading = false  })
        // DETAIL CLIENT
        .addCase(detailClient.pending,(state) => { state.currentClientLoading = true })
        .addCase(detailClient.fulfilled,(state, action) => { 
            state.loading = false;
            state.current = action.payload
            state.currentClientLoading = false
        })
        .addCase(detailClient.rejected, (state) => { state.currentClientLoading = false }) 
         // EDIT CLIENT
         .addCase(editClient.pending,(state) => { state.loading = true })
         .addCase(editClient.fulfilled,(state, action) => { 
             state.loading = false;
             state.current = action.payload
         })
         .addCase(editClient.rejected, (state) => { state.loading = false  })
        // CAN DELETE CLIENT
        .addCase(canDeleteClient.pending,(state) => { state.loading = true })
        .addCase(canDeleteClient.fulfilled,(state, action) => { 
            state.loading = false;
            state.canDeleteCurrent = action.payload
        })
        .addCase(canDeleteClient.rejected, (state) => { state.loading = false  }) 
         // DELETE CLIENT
         .addCase(deleteClient.pending,(state) => { state.loading = true })
         .addCase(deleteClient.fulfilled,(state, action) => {
             state.loading = false;
             state.current = []
         })
         .addCase(deleteClient.rejected, (state) => { state.loading = false  })
        // ADD BRANCH
        .addCase(addBranch.pending,(state) => { state.loading = true })
        .addCase(addBranch.fulfilled,(state, action) => {
            state.loading = false;
            state.current = action.payload;
        })
        .addCase(addBranch.rejected,(state) => { state.loading = false })
        // UPDATE BRANCH
        .addCase(updateBranch.pending,(state) => { state.loading = true })
        .addCase(updateBranch.fulfilled,(state, action) => {
            state.loading = false;
            state.current = action.payload;
        })
        .addCase(updateBranch.rejected,(state) => { state.loading = false })
        // DELETE BRANCH
        .addCase(deleteBranch.pending,(state) => { state.loading = true })
        .addCase(deleteBranch.fulfilled,(state, action) => {
            state.loading = false;
        })
        .addCase(deleteBranch.rejected,(state) => { state.loading = false })
    }
});

export default clientSlice.reducer; 